var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backend"},[(_vm.loading)?_c('LoadingScreen'):_vm._e(),(!_vm.loading)?_c('TheHeader'):_vm._e(),(!_vm.loading)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }